// The desktop (Electron) build loads the UI via the file:// protocol; the web
// build is always served over http(s). Shared by index.js (router choice) and
// App.js (skipping the login screen on desktop).
export const isDesktopApp = window.location.protocol === "file:";
